import { Link } from 'react-router';
import { buttonVariants } from '@/components/ui/button';
import { EmptyState } from './EmptyState';

/**
 * The app's "Không tìm thấy trang": an unknown address, and a record page whose record is hidden or missing where the
 * product answers both the same way (the MCP confirm page, S2 §9.3).
 */
export function NotFoundState() {
  return (
    <EmptyState
      title="Không tìm thấy trang"
      action={<Link className={buttonVariants()} to="/">Về Dashboard</Link>}
    >
      Đường dẫn này không còn hoặc chưa được mở. Hãy dùng thanh điều hướng.
    </EmptyState>
  );
}
